// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-select-dropdown {
	color: var(--text) !important;
	background-color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/CRM/ticket/ticketModule.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;CAC7B,iCAAiC;AAClC","sourcesContent":[".ant-select-dropdown {\n\tcolor: var(--text) !important;\n\tbackground-color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
